<template>
	<div>
		<div v-if="loader" class="flex center text-center mb-1">
			<i class="fas fa-cog fa-spin fa-2x"></i>
			Loading....
		</div>
		<form v-if="!loader" class="list-filter flex box" method="get" :action="endPoint" ref="filterForm">
			<div class="two form-group">
				<label for="limit"><i class="fas fa-fw fa-list-ul"></i> Show</label>
				<select id="limit" name="limit" @change="changeLimit" v-model="selectedLimit">
					<option value="null">25</option>
					<option value="50">50</option>
					<option value="100">100</option>
				</select>
			</div>

			<div class="ten form-group">
				<label for="filter"><i class="fas fa-fw fa-filter"></i> Filter</label>
				<div class="input-group">
					<input id="filter" class="input-small" name="filter" type="text" placeholder="Filter in Name" v-model="filterString" @keyup="filter">
					<button class="btn btn-primary" :disabled="!this.filterEnabled" @click="clearForm">Filter</button>
				</div>
			</div>
		</form>
		<slot name="content" :filterString="filterString"></slot>
	</div>
</template>

<script>
	import {eventBus} from "../../../app";

	export default {
		props: {
			dataEndpoint: {
				type: String
			},
			dataUrlParams: {
				type: Object,
				required: false
			}
		},

		data() {
			return {
				filterString: '',
				endPoint: this.dataEndpoint,
				urlParams: this.dataUrlParams || {},
				loader: false,
				filterEnabled: this.dataUrlParams.filter && this.dataUrlParams.filter.length > 0,
				selectedLimit: this.dataUrlParams.limit ? this.dataUrlParams.limit : null,
			}
		},

		methods: {
			changeLimit: function () {
				eventBus.$emit('changeLimit', this.selectedLimit);
			},
			filter: function () {
				eventBus.$emit('filter', this.filterString);
			},
			clearForm: function () {
				$('input, select').each(function (_, inp) {
					if ($(inp).val() === '' || $(inp).val() === 'null' || $(inp).val() === null)
						inp.disabled = true;
				});
			},
			checkReset: function () {
				if (this.urlParams.filter.length === 0) {
					this.onFormChange();
				}
			},
			onFormChange: function () {
				this.loader = true;
				this.clearForm();
				this.$refs.filterForm.submit();
			},
			onFilterChange: function () {
				this.filterEnabled = this.urlParams.filter && this.urlParams.filter.length > 0;
			},
		}
	}
</script>

<style scoped>

</style>
